var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("UiButton", {
    attrs: {
      buttonText: "Resend invitation",
      size: "no",
      variant: "linkButton",
      processing: _vm.processing,
    },
    on: {
      click: function ($event) {
        return _vm.$emit("resendInvitationClicked")
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }